const BASE_URL = process.env.REACT_APP_API_ENDPOINT
const BASE_PATH = '/api/v1/auth/'

export default {
  getConfig: `${BASE_URL}${BASE_PATH}config/`
}
